import { Injectable } from '@angular/core';
import { supabase } from '../../core/supabase/supabase.client';

export interface CatalogSponsorship {
  is_sponsored: boolean;
  priority: number;
  starts_at: string | null;
  ends_at: string | null;
}

@Injectable({ providedIn: 'root' })
export class CatalogMerchandisingService {
  async get(storeId: number, productId: number): Promise<CatalogSponsorship> {
    const { data, error } = await supabase.from('store_product_merchandising')
      .select('is_sponsored,priority,starts_at,ends_at').eq('store_id', storeId).eq('product_id', productId).maybeSingle();
    if (error) throw error;
    return data ?? { is_sponsored: false, priority: 0, starts_at: null, ends_at: null };
  }

  async save(storeId: number, productId: number, value: CatalogSponsorship): Promise<void> {
    if (!Number.isInteger(value.priority) || value.priority < 0 || value.priority > 100) throw Error('Priority must be a whole number from 0 to 100.');
    const dates = [value.starts_at, value.ends_at];
    if (dates.some(date => date && !Number.isFinite(Date.parse(date)))) throw Error('Enter valid schedule dates.');
    if (value.starts_at && value.ends_at && Date.parse(value.ends_at) <= Date.parse(value.starts_at)) throw Error('End must be after start.');
    const { error } = await supabase.rpc('admin_save_store_merchandising', {
      p_store_id: storeId, p_product_id: productId, p_is_sponsored: value.is_sponsored,
      p_priority: value.priority, p_starts_at: value.starts_at, p_ends_at: value.ends_at,
    });
    if (error) throw error;
  }
}
